import messages from './info-modal-translations';

export default {
    name: 'instamapsInfoModal',
    i18n: {
        messages,
    },
    data: function () {
        return {
            htmlAttribution: '',
        };
    },
    props: {
        name: { type: String },
        author: { type: String },
        lastUpdated: { type: String },
        creationDate: { type: String },
        mapOptions: {},
        show: { type: Boolean },
        isAtlasMode: { type: Boolean },
        attribution: { type: String },
    },
    computed: {
        lastUpdatedDate: function () {
           return new Date(this.lastUpdated).toLocaleString();
        },
        description: function () {
            return (this.mapOptions === undefined || this.mapOptions.description === '') ? '-' : this.mapOptions.description;
        },
        fixedId: function () {
            return (this.isAtlasMode) ? 'fixed-modal' : 'info-modal-partial';
		},
		tags: function () {
			return (this.mapOptions === undefined || this.mapOptions.tags === '') ? '-' : this.mapOptions.tags;
        },
        creationDateF: function () {
            return new Date(this.creationDate).toLocaleString();
        }
    },
    methods: {
        dismiss: function () {
            this.$emit('closeInfoModal');
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/info-modal/info-modal.js